export default __webpack_public_path__ + "static/media/IconDesc_DarkMatter.64.2898f3e0.png";